/**
 * Faceted search - Clear button
 *
 * Implements the functionality of the "Clear" -button in the text field in faceted search.
 */

(() => {
    let form = document.querySelector('.js-faceted-search-form');
    let text_field = document.querySelector('.js-faceted-search-text-field');
    let clear_button = document.querySelector(
        '.js-faceted-search-text-field-clear-button'
    );

    if (!form || !text_field || !clear_button) {
        return;
    }

    function clearTextField(e) {
        text_field.value = '';
        text_field.focus();
        form.dispatchEvent(new Event('input'));
    }

    function updateVisibility(e) {
        clear_button.classList.toggle('-visible', text_field.value !== '');
    }

    clear_button.addEventListener('click', clearTextField);
    form.addEventListener('input', updateVisibility);
    text_field.addEventListener('input', updateVisibility);

    updateVisibility();
})();
